





import { defineComponent } from '@vue/composition-api';

import PanelWithPurchaseOrderRevise from '@/components/PurchaseOrder/PanelWithPurchaseOrderRevise.vue';

const Edit = defineComponent({
  components: {
    PanelWithPurchaseOrderRevise,
  },
  // setup() {},
});

export default Edit;
